import services from "../../../../libs/services";
import EmitEvent, {HT_RESIZE, OBSERVER_HEIGHT_CHANGED, PAGE_LOADED,} from "../../../../libs/emit-event";
import AnimationChars from "../../../animation/chars/chars";
import AnimationFade from "../../../animation/fade/fade";

export class ProjectItemMobile {

    constructor({el, elHeading, addGroup, index, indexActive, getDragValue}) {
        this.DOM = {el, elHeading};
        this.DOM.thumbnail = this.DOM.el.querySelector('.projectPageItem_thumbnail');
        this.prop = {top: 0, translate: 0};
        this.addGroup = addGroup;
        this.index = index;
        this.indexOnHold = indexActive;
        this.getDragValue = getDragValue;

        this.animations = {
            heading: new AnimationChars(this.DOM.elHeading.querySelector('.js-projectsPage_names_heading'), {type: '2d'}),
            year: new AnimationFade(this.DOM.elHeading.querySelector('.js-projectsPage_names_meta_year')),
            button: new AnimationFade(this.DOM.elHeading.querySelector('.js-projectsPage_names_meta_button')),
        };

        if (this.index === this.indexOnHold) {
            this.DOM.elHeading.style.zIndex = '1';
            this.DOM.elHeading.style.pointerEvents = 'auto';
        } else {
            this.DOM.elHeading.style.zIndex = '0';
            this.DOM.elHeading.style.pointerEvents = 'none';
        }

        this.pageLoaded = this.pageLoaded.bind(this);
        this.pageResize = this.pageResize.bind(this);

        this.bindEvent();
    }

    getProp() {
        const {top, left, width} = this.DOM.el.getBoundingClientRect();
        this.prop = {top, left: (left - this.getDragValue()), width};
    }

    animationTextIn() {

        this.DOM.elHeading.style.zIndex = '1';
        this.DOM.elHeading.style.pointerEvents = 'auto';

        this.animations.heading.animationIn();
        this.animations.year.animationIn(.25);
        this.animations.button.animationIn(.3);
    }

    animationTextOut() {

        this.DOM.elHeading.style.zIndex = '0';
        this.DOM.elHeading.style.pointerEvents = 'none';

        this.animations.heading.animationOutBottomAll();
        this.animations.year.animationOut();
        this.animations.button.animationOut();
    }

    getFocus() {
        return ((this.prop.left + (this.prop.width / 2)) - (services.winSize.width / 2));
    }

    dragging(x) {
        this.DOM.el.style.transform = `translate(${x}px, 0)`;
    }

    clearDragging() {
        this.DOM.el.style.transform = null;
    }

    draggingTestActive(x, triggerActive) {
        const left = this.prop.left + x;
        const disLeft = left + this.prop.width;
        if (left < triggerActive.triggerStart && disLeft > triggerActive.triggerEnd) {
            return true;
        }
        return false;
    }

    pageLoaded() {
        this.getProp();
    }


    pageResize() {
        this.getProp();
    }

    bindEvent() {
        EmitEvent.on(HT_RESIZE, this.pageResize);
        EmitEvent.on(OBSERVER_HEIGHT_CHANGED, () => {
            this.pageResize();
        });
        EmitEvent.on(PAGE_LOADED, this.pageLoaded);
    }

    removeEvent() {
        EmitEvent.off(HT_RESIZE, this.pageResize);
        EmitEvent.off(OBSERVER_HEIGHT_CHANGED, this.pageResize);
        EmitEvent.off(PAGE_LOADED, this.pageLoaded);
    }
}